var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClean8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 508 508",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M493.9,85.1H300.2C158.5,85.1,0,201.4,0,357.1c0,7.8,6.3,14.1,14.1,14.1h479.8c7.8,0,14.1-6.3,14.1-14.1V99.2 C508,91.4,501.7,85.1,493.9,85.1z M479.8,343L479.8,343H28.7C38,210.6,176.2,113.3,300.2,113.3h179.6V343z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M437.4,141.6H300.2c-70.8,0-147.6,36.3-195.6,92.6c-3.6,4.2-4.4,10.1-2.1,15.1s7.3,8.2,12.8,8.2h322.1 c7.8,0,14.1-6.3,14.1-14.1v-87.7C451.5,147.9,445.2,141.6,437.4,141.6z M423.3,229.3H390c0-7.8-6.3-14.1-14.1-14.1h-94.6 c-7.8,0-14.1,6.3-14.1,14.1H149.1c42.1-36.8,98.5-59.5,151-59.5h123.2V229.3z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M435.2,394.7H14.1C6.3,394.7,0,401,0,408.8s6.3,14.1,14.1,14.1h421.1c7.8,0,14.1-6.3,14.1-14.1 C449.3,401,443,394.7,435.2,394.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClean8);
export default __webpack_public_path__ + "static/media/clean8.91fdd4ee2daeac1569bd838939d2a801.svg";
export { ForwardRef as ReactComponent };